import { MaintenanceService } from '@services/maintenance.service';

import { MenuService } from '@services/menu.service';
import { SessionService } from '@services/session.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { NavController, MenuController } from '@ionic/angular';
import { EnumAppMenu } from '@models/AppMenus';
import { EnumPageStates } from '@pages/error/error.page';


@Injectable({
    providedIn: 'root'
})
class GuardAuthService {

    constructor(private router: Router,
        private MenuService: MenuService,
        private SessionService: SessionService,
        private NavController: NavController,
        private MenuController: MenuController
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return this.canForwardRoute(state);
    }

    private async canForwardRoute(state?: RouterStateSnapshot): Promise<boolean> {

        const hasSession = this.SessionService.HasSession();

        if (!hasSession) {

            this.MenuController.enable(false);
            this.NavController.navigateRoot(EnumAppMenu.Login);

        }
        else {

            /**
             * 
             */
            const menusStatic: string[] = [
                EnumAppMenu.Notifications,
                EnumAppMenu.Settings,
                EnumAppMenu.Account,
                EnumAppMenu.Support,
                EnumAppMenu.Maintenance,
                // TODO [dev/temporário]: a nova página de estatísticas ainda não está no menu
                // dinâmico do backend. Este bypass permite abri-la por URL durante o desenvolvimento.
                // Remover quando o item de menu existir (ou ao substituir a página atual).
                'configurations/statistics-v2'
            ];

            if (!menusStatic.some(it => it.includes(state?.url?.replace('/', '')))) {

                this.MenuController.enable(true);

                const menus = await this.MenuService.GetMenus();

                const menuAvailabled = await this.MenuService.SetMenuByPath(state?.url || null);

                if (menus?.length == 0 && !menuAvailabled) this.NavController.navigateRoot(EnumAppMenu.Error, { queryParams: { id: EnumPageStates.SESSIONENDED } });
                else if (!menuAvailabled) this.NavController.navigateRoot(EnumAppMenu.Error, { queryParams: { id: EnumPageStates.NOTFOUND } });
            }
        }

        return true;
    }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
    return inject(GuardAuthService).canActivate(next, state);
}

